export const OUTPUT_SCALE = 2;
export const PDF_TO_CSS_UNITS = 96.0 / 72.0;
